import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { useThemeMode } from '../contexts/ThemeModeContext';
import { useLanguage } from '../contexts/LanguageContext';

function ThemeToggle() {
  const { mode, toggleMode } = useThemeMode();
  const { translate } = useLanguage();

  const isLight = mode === 'light';

  return (
    <Tooltip title={translate(isLight ? 'theme.switchToDark' : 'theme.switchToLight')}>
      <IconButton onClick={toggleMode} color="primary" size="large" aria-label={translate('theme.toggleLabel')}>
        {isLight ? <DarkModeIcon /> : <LightModeIcon />}
      </IconButton>
    </Tooltip>
  );
}

export default ThemeToggle;
